export class Session {
	token: string;
	refreshToken: string;
}
